<template>
  <section class="promo-banner">
    <div class="promo-banner__content">
      <div class="promo-banner__headline">
        <h2 class="promo-banner__title">
          Приложение руководителя с AI-ассистентом
        </h2>
        <span class="promo-banner__badge">
          СКОРО
        </span>
      </div>
      <div class="promo-banner__subtitle">
        Не открывайте отчёты. Просто спросите
      </div>
    </div>

    <!-- карусель пока из одного слайда: точки держат место под следующие баннеры -->
    <div class="promo-banner__dots">
      <span class="promo-banner__dot promo-banner__dot_active"></span>
      <span class="promo-banner__dot"></span>
      <span class="promo-banner__dot"></span>
    </div>
  </section>
</template>

<script>
  export default {
    name: 'PromoBanner',
  }
</script>

<style lang="less" scoped>
.promo-banner {
  position: relative;
  display: flex;
  align-items: center;
  // кадр с телефоном ушёл в правый край фона — пропорции держим по макету,
  // иначе героя обрезает по грудь
  aspect-ratio: 2362 / 193;
  min-height: 116px;
  padding: 0 40px;
  border-radius: 8px;
  overflow: hidden;
  background-color: #040404;
  background-image: url('/img/billing/banner-kitchen.png');
  background-size: cover;
  background-position: right center;
  background-repeat: no-repeat;

  .media-md({
    padding: 0 24px;
  });

  .media-sm({
    aspect-ratio: auto;
    padding: 20px 24px;
    background-position: 75% center;
  });

  &__content {
    position: relative;
    z-index: 1;
    max-width: 60%;

    .media-sm({
      max-width: 100%;
    });
  }

  &__headline {
    display: flex;
    align-items: baseline;
    gap: 14px;
  }

  &__title {
    font-size: 28px;
    font-weight: 700;
    line-height: 1.15;
    color: #fff;

    .media-md({
      font-size: 22px;
    });

    .media-xs({
      font-size: 18px;
    });
  }

  &__badge {
    flex: 0 0 auto;
    position: relative;
    top: -0.8em;
    font-size: 17px;
    color: #ea306b;

    .media-md({
      font-size: 14px;
    });
  }

  &__subtitle {
    margin-top: 10px;
    font-size: 18px;
    color: @color-primary;

    .media-md({
      font-size: 15px;
    });
  }

  &__dots {
    position: absolute;
    left: 50%;
    bottom: 14px;
    transform: translateX(-50%);
    display: flex;
    gap: 16px;

    .media-sm({
      display: none;
    });
  }

  &__dot {
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: #666;

    &_active {
      background-color: @color-primary;
    }
  }
}
</style>
